export default __webpack_public_path__ + "static/media/internal-engine.4d9ec83d.svg";